import { Accordion, AccordionDetails, AccordionSummary, Box, Button, CircularProgress, Dialog, DialogActions, DialogContent, DialogTitle, IconButton, Stack, Typography } from "@mui/material";
import { Component } from "react";
import { BsBuilding } from "react-icons/bs";
import BasicDataGrid from "../../ui/BasicDataGrid";
import { MdAdsClick, MdDelete, MdEdit } from "react-icons/md";
import NomeInput from "../../ui/NomeInput";
import { httpGet, httpPost } from "../../util/http";
import StatusAlert from "../../ui/StatusAlert";
import UnidadeSelect from "../../ui/UnidadeSelect";
import CodDepInput from "../../ui/CodDep";
import RoundButton from "../../ui/RoundButton";
import TipoMetaSelect from "../../ui/TipoMetaSelect";
import MetaInvInput from "../../ui/MetaInvInput";
import PontosInput from "../../ui/PontosInput";

// tipo (TipoMetaSelect) -> type esperado pelo MetaInvInput
const TIPO_META_INPUT_TYPE = {
    1: 'monetary',   // Diferença de Inventário
    2: 'integer',    // Itens Ajustados
    3: 'integer',    // Estoque Avaria
    4: 'percentage', // Percentual Romaneio
    5: 'integer',    // Contagem Semanal
    6: 'time',       // Tempo de Contagem
};

export default class Metas extends Component {

    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            showForm: false,
            showDelete: false,
            metas: [],
        }
        this.columns = [
            { field: 'unidade', headerName: 'Unidade', flex: 1, valueGetter: (params) => params.row?.unidade?.nome },
            { field: 'tipo', headerName: 'Tipo', flex: 1, valueGetter: (params) => params.row?.tipo?.nome },
            { field: 'meta1', headerName: 'Meta 1º Inv.', width: 110, valueGetter: (params) => params.row?.metainv1 },
            { field: 'meta2', headerName: 'Meta 2º Inv.', width: 110, valueGetter: (params) => params.row?.metainv2 },
            { field: 'anual', headerName: 'Meta anual',  width: 110, valueGetter: (params) => params.row?.anual },
            { field: 'pontos', headerName: 'Pontos', width: 60, valueGetter: (params) => params.row?.pontos },
            {
                field: 'action', headerName: 'Ações', width: 100, renderCell: (params) => <>
                    <IconButton title="Editar" onClick={e => this.onEditClick(params)} color="primary"><MdEdit size={16} /></IconButton>
                    <IconButton title="Remover" onClick={e => this.onRemoveClick(params)} color="primary"><MdDelete size={16} /></IconButton>
                </>
            },
        ];
    }

    componentDidMount() {
        this.refresh();
    }

    refresh() {
        this.setState({ loading: true });
        httpGet('/metas/list',
            metas => {
                this.setState({
                    metas: metas,
                    loading: false,
                });
            },
            error => {
                console.log(error);
                this.setState({ loading: false });
            },
        );
    }

    getMetaInputType() {
        return TIPO_META_INPUT_TYPE[this.state.tipo?.tipo] || 'integer';
    }

    onSubmit(e) {
        e.preventDefault();

        if (!this.state.unidade) {
            this.setState({ unidadeErr: true })
            return;
        }

        if (!this.state.tipo) {
            this.setState({ tipoErr: true })
            return;
        }

        if (this.state.meta1 === '' || this.state.meta1 === null || this.state.meta1 === undefined) {
            this.setState({ meta1Err: true })
            return;
        }

        if (this.state.meta2 === '' || this.state.meta2 === null || this.state.meta2 === undefined) {
            this.setState({ meta2Err: true })
            return;
        }

        if (this.state.pontos === '' || this.state.pontos === null || this.state.pontos === undefined) {
            this.setState({ pontosErr: true })
            return;
        }

        this.setState({
            showAlert: false,
            btnLoading: true
        });

        httpPost('/metas/save',
            {
                id: this.state.currId,
                tipo: this.state.tipo?.tipo,
                pontos: this.state.pontos,
                unidadeId: this.state.unidade?.id,
                meta1: this.state.meta1,
                meta2: this.state.meta2,
            },

            resp => {
                this.refresh();
                this.setState({ showForm: false });
            },

            error => {
                this.setState({
                    showAlert: true,
                    btnLoading: false,
                    msg: 'Falha ao salvar.',
                    extraMsg: error.message
                });
            },

            false
        );
    }

    onDelete(e) {
        e.preventDefault();

        this.setState({
            showAlert: false,
            btnLoading: true
        });

        httpPost('/metas/' + this.state.currId + '/delete',
            {
                delete: true
            },

            resp => {
                this.refresh();
                this.setState({ showDelete: false });
            },

            error => {
                this.setState({
                    showAlert: true,
                    btnLoading: false,
                    msg: 'Falha ao salvar.',
                    extraMsg: error.message
                });
            },

            false
        );
    }

    onAddClick() {
        this.setState({
            currId: undefined,
            showForm: true,
            pontos: '',
            pontosErr: false,
            meta1: '',
            meta1Err: false,
            meta2: '',
            meta2Err: false,
            tipo: null,
            tipoErr: false,
            unidade: null,
            unidadeErr: false,
            showAlert: false,
            btnLoading: false,
        });
    }

    onEditClick(params) {
        this.setState({
            currId: params.row?.id,
            showForm: true,
            pontos: params.row?.pontos,
            pontosErr: false,
            meta1: params.row?.metainv1,
            meta1Err: false,
            meta2: params.row?.metainv2,
            meta2Err: false,
            tipo: params.row?.tipo,
            tipoErr: false,
            unidade: params.row?.unidade,
            unidadeErr: false,
            showAlert: false,
            btnLoading: false,
        });
    }

    onRemoveClick(params) {
        this.setState({
            currId: params.row?.id,
            showDelete: true,
            showAlert: false,
            btnLoading: false,
        });
    }

    render() {
        const metaInputType = this.getMetaInputType();

        return (
            <Stack>
                <Dialog open={this.state.showDelete}>
                    <form onSubmit={event => this.onDelete(event)}>
                        <DialogTitle color="primary" fontSize={12}>REMOVER META</DialogTitle>
                        <DialogContent>
                            <Stack width={400} gap={2} mt={1}>
                                <Typography variant="caption">Tem certeza que deseja remover?</Typography>
                            </Stack>
                            {this.state.showAlert &&
                                <Stack mt={1} width="calc(100%)"><StatusAlert type="err" msg={this.state.msg} extra={this.state.extraMsg} /></Stack>}
                        </DialogContent>
                        <DialogActions>
                            {this.state.btnLoading ? <CircularProgress size={20} /> : <RoundButton submit>Sim</RoundButton>}
                            <RoundButton disabled={this.state.btnLoading} onClick={e => this.setState({ showDelete: false })}>Não</RoundButton>
                        </DialogActions>
                    </form>
                </Dialog>
                {/* ---------------------------------------------------------------------- */}
                <Dialog open={this.state.showForm}>
                    <form onSubmit={event => this.onSubmit(event)}>
                        <DialogTitle color="primary" fontSize={12}>{this.state.currId ? "EDITAR META" : "ADICIONAR META"}</DialogTitle>
                        <DialogContent>
                            <Stack width={500} gap={2} mt={1}>
                                <Stack direction="row" gap={2}>
                                    <UnidadeSelect sx={{ flex: 1 }} value={this.state.unidade} onChange={(unidade) => this.setState({ unidade, unidadeErr: false })} error={this.state.unidadeErr} />
                                </Stack>
                                <TipoMetaSelect
                                    value={this.state.tipo}
                                    sx={{ flex: 1 }}
                                    onChange={(tipo) => this.setState({ tipo, tipoErr: false })}
                                    error={this.state.tipoErr} />
                                <Stack direction="row" gap={2}>
                                    <MetaInvInput
                                        label="Meta 1º Inv."
                                        type={metaInputType}
                                        value={this.state.meta1}
                                        sx={{ flex: 1 }}
                                        onChange={(meta1) => this.setState({ meta1, meta1Err: false })}
                                        error={this.state.meta1Err} />
                                    <MetaInvInput
                                        label="Meta 2º Inv."
                                        type={metaInputType}
                                        value={this.state.meta2}
                                        sx={{ flex: 1 }}
                                        onChange={(meta2) => this.setState({ meta2, meta2Err: false })}
                                        error={this.state.meta2Err} />
                                    <PontosInput value={this.state.pontos} sx={{ flex: 1 }} onChange={(pontos) => this.setState({ pontos, pontosErr: false })} error={this.state.pontosErr} />
                                </Stack>

                                {this.state.showAlert &&
                                    <Stack mt={1} width="calc(100%)"><StatusAlert type="err" msg={this.state.msg} extra={this.state.extraMsg} /></Stack>}
                            </Stack>
                        </DialogContent>
                        <DialogActions>
                            {this.state.btnLoading ? <CircularProgress size={20} /> : <RoundButton submit>Salvar</RoundButton>}
                            <RoundButton disabled={this.state.btnLoading} onClick={e => this.setState({ showForm: false })}>Cancelar</RoundButton>
                        </DialogActions>
                    </form>
                </Dialog>
                {/* ---------------------------------------------------------------------- */}
                <Accordion>
                    <AccordionSummary>
                        <Typography variant="body2" color="primary"><MdAdsClick size={16} /><Box ml={1} component="span"><b>Cadastro de metas</b></Box></Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                        <Box mt={-2} mb={1} borderBottom={1} borderColor="primary.main"></Box>
                        <Typography mt={1} variant="caption" color="primary">Faça aqui o cadastro de metas usadas pela apuração de inventário.</Typography>
                        <Box><Button color="btnStyle" onClick={e => this.onAddClick()} size="small" variant="contained" disableElevation>Cadastrar</Button></Box>
                        <Box mt={1}>
                            <BasicDataGrid
                                dense
                                props={{
                                    loading: this.state.loading
                                }} rows={this.state.metas} columns={this.columns} />
                        </Box>
                    </AccordionDetails>
                </Accordion>
            </Stack>
        );
    }
}